import { createAction } from '@reduxjs/toolkit';

export const setBonuses = createAction('user/bonuses/set');
